import { createContext, useContext, type ReactNode } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api, post } from './api';
import type { Role } from '@chordverse/shared';
export type User = {
  id: string;
  email: string;
  displayName: string;
  slug: string;
  role: Role;
  approvedContributionCount: number;
  emailVerifiedAt: string | null;
};
const Context = createContext<{ user: User | null; loading: boolean; logout: () => Promise<void> }>(
  { user: null, loading: true, logout: async () => {} },
);
export function AuthProvider({ children }: { children: ReactNode }) {
  const client = useQueryClient();
  const query = useQuery({
    queryKey: ['me'],
    queryFn: () => api<{ user: User | null }>('/auth/me'),
    retry: false,
  });
  const logout = async () => {
    await post('/auth/logout');
    client.setQueryData(['me'], { user: null });
  };
  return (
    <Context.Provider value={{ user: query.data?.user ?? null, loading: query.isLoading, logout }}>
      {children}
    </Context.Provider>
  );
}
export const useAuth = () => useContext(Context);
